<template>
  <div class="outer-container">
    <div class="container">
      <div class="inner-container">
        <h2 class="header-font text-center">Course Outline</h2>

        <hr style="background-color:#ff636b; padding:0px 200px" />
        <div class="" v-if="outlineContent">
          <div class="grid" v-for="i in outlineContent" :key="i.classNumber">
            <div class="">
              <h2>{{ i.classNumber }}</h2>
              <h3>
                {{ i.classSub }}
              </h3>
            </div>
            <div class="">
              <ul v-for="(j, index) in i.orderList" :key="index">
                <li>
                  <h5>
                    {{ index + 1 }}
                    .{{ j }}
                  </h5>
                </li>
              </ul>
            </div>
            <!-- <hr style="background-color:white; padding:0px 200px" /> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      outlineContent: [
        {
          classNumber: 'Class 1',
          classSub: 'Design Process ',
          orderList: [
            'Fundamentals of UX Design ',
            'UX Design Honeycomb ',
            'Elements of UX Design ',
            'Develop basic skills in creative problem-solving,  innovation, and ,human-centered design through a fast-paced design thinking activity ',
          ],
        },
        {
          classNumber: 'Class 2',
          classSub: 'Design Process ',
          orderList: [
            'Generalized overview UX Design Process',
            'Defining User Goals and User Flows',
            'Understanding the business Problems',
            'User story, User Journey, User Flow Diagram, Competitive Analysis',
          ],
        },
        {
          classNumber: 'Class 3',
          classSub: 'Design & Prototyping Tools ',
          orderList: [
            ' Introduction to Adobe XD and Figma.Basics of to design and prototype and share ',
            'User Interface (UI) Design Fundamentals ',
          ],
        },
        {
          classNumber: 'Class 4',
          classSub: 'UI Design  ',
          orderList: [
            'Basics of visual design like color theory, alignment, ',
            'spacing, padding, elements, contrast, etc. ',
            ' Design Deliverables ',
            ' Design Hand-off for Development ',
            ' Component-Based Design ',
          ],
        },
        {
          classNumber: 'Class 5',
          classSub: 'Design Onboarding  ',
          orderList: [
            ' Project-based design ',
            ' Define metrics to validate design decision ',
            'Design Documentation ',
            ' Measuring Design Efforts ',
            ' Data-driven Design Decision ',
            ' User Research for Design Validations ',
            ' Analytical Tools to Measure Design',
          ],
        },
        {
          classNumber: 'Class 6',
          classSub: 'Build and Test  ',
          orderList: [
            'Practice designing an onboarding experience that communicates.',
            'Run three usability tests using best practices. ',
          ],
        },
        {
          classNumber: 'Class 7',
          classSub: ' Providing Service  ',
          orderList: [
            'The current industry of UX design.',
            'Career and Freelancing Opportunity. ',
            'How to build your portfolio.',
            'How to land your first job as a UX designer',
          ],
        },
        {
          classNumber: 'Class 8',
          classSub: 'Final Project Review  ',
          orderList: ['Provide feedback on each project and Q/A'],
        },
      ],
    }
  },
}
</script>

<style scoped>
ul {
  list-style: none;
}
ul li h5 {
  padding-top: 12px;
  font: 400 1rem/1.2rem 'Manrope';
}
.outer-container {
  padding: 100px 0;
  background-color: #f8f8f9;
}
hr {
  margin: 55px 0;
}
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding-top: 50px;
  grid-gap: 55px;
  padding-bottom: 60px;
  border-bottom: 1px solid #ff636b;
}

.grid h5 {
  padding-top: 0;
  font: 700 1rem/1.25rem 'Manrope';
  color: white;
}
.grid h2 {
  font: 700 3.25rem/4rem 'Manrope';
  color: #fbbf05;
}
.grid h3 {
  font: 700 1.5rem/1.75rem 'Manrope';
  color: white;
}
.inner-container {
  max-width: 1300px;
  margin: 0 auto;
  padding: 20px 150px;
  background-color: #7d020a;

  padding-bottom: 80px;
}
.header-font {
  padding-top: 70px;
  font: 800 2.25rem/2.75rem 'Manrope';
  color: white;
  padding-bottom: 50px;
}
ol li {
  font: 400 1rem/1.125rem 'Manrope';
  color: white;
}
ul li {
  font: 400 1rem/1.125rem 'Manrope';
  color: white;
}
@media only screen and (max-width: 600px) {
  .grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 55px;
  }
  .inner-container {
    max-width: 100%;
    margin: 0 auto;
    padding: 20px 20px;
  }
  ol {
    padding-left: 20px;
  }
  ul {
    padding-left: 30px;
  }
  ol li {
    font: 400 1rem/1.125rem 'Manrope';
    color: white;
  }
  ul li {
    font: 400 1rem/1.125rem 'Manrope';
    color: white;
  }
}
</style>
